export default __webpack_public_path__ + "static/media/ForgotPassword-documentation.b35129fe.md";